import ValidateHelper from "../../helpers/ValidateHelper";

const Validate = (inputs, arrays = false) => {
	

	const geofence_id = ValidateHelper({
		input: inputs.geofence_id,
		attribute: 'Geocerca',
		required: true, 
		type: 'integer'
	});
	const platform_price = ValidateHelper({
		input: inputs.platform_price,
		attribute: 'Pago de plataforma',
		required: true, 
		type: 'number'
	});
	const max_speed = ValidateHelper({
		input: inputs.max_speed,
		attribute: 'Velocidad Máxima',
		required: true, 
		type: 'number'
	});
	const pasage_price = ValidateHelper({
		input: inputs.pasage_price,
		attribute: 'Precio de pasaje',
		required: true, 
		type: 'number'
	});
	let errors = {
		geofence_id: [],
		platform_price: [],
		max_speed:[],
		pasage_price:[]
	};

	let flag = false;


	if (geofence_id != undefined){
		errors.geofence_id = [geofence_id];
		flag = true;
	}
	if (platform_price != undefined){
		errors.platform_price = [platform_price];
		flag = true;
	}
	if (max_speed != undefined){
		errors.max_speed = [max_speed];
		flag = true;
	}
	if (pasage_price != undefined){
		errors.pasage_price = [pasage_price];
		flag = true;
	}

	return flag ? errors : undefined;
}

export default Validate;